<template>
  <div class="belong_class pd2430">
    <p class="fs18 tac lh40">{{ title }}</p>
    <div class="count lh40">
      <span>班级成员：</span>
      <span>{{ total }}人</span>
    </div>
    <!-- 搜索 -->
    <div class="search flex_X">
      <el-input placeholder="请输入学员名称" v-model="inputVal" clearable>
      </el-input>
      <div class="el-icon-search sousuo pointer" @click="searchFn"></div>
    </div>
    <!-- 列表 -->
    <ul class="uu pdtb24" v-if="total !== 0">
      <li v-for="(item, index) in studentArr">
        <el-avatar :size="80" :src="item.image"></el-avatar>
        <p>{{ item.truename }}</p>
        <!-- <el-button @click="privateLetter">私信TA</el-button> -->
      </li>
    </ul>

    <Empty v-else></Empty>
    <!-- 分页 -->
    <Pagination
      :currentPage="currentPage"
      :pageSize="pageSize"
      :total="total"
      :is_have="1"
      :selectSize="[15]"
      @changePage="changePage"
      @changeSize="changeSize"
      v-if="total !== 0"
    ></Pagination>
  </div>
</template>

<script>
import { StudentList, GroupList } from "@/api/student";
export default {
  data() {
    return {
      inputVal: "", // 成员名称
      defalutImg:
        "https://dckj.ks3-cn-guangzhou.ksyun.com/ltedu3/20200318/d3904597-eff5-4048-8808-8183b2b64c7a.png",
      currentPage: 1, //当前页数
      pageSize: 15, // 当前页条数
      total: 11, // 总数
      studentArr: [],
      class_id: "",
      title: "",
      path: "", //
    };
  },

  watch: {
    // 监听路由变化
    $route(to, from) {
      if (to.fullPath != from.fullPath) {
        this.currentPage = 1;
        this.inputVal = "";
        this.title = this.$route.query.title;
        // this.type = this.$route.query.type;
        this.path = this.$route.path;
        this.requestCommonFn();
      }
    },
  },
  methods: {
    // 私信TA
    privateLetter() {
      this.messageTips("正在开发中...");
      //   this.dialogTableVisible = true;
    },
    requestCommonFn() {
      if (this.path == "/BelongClass") {
        // 学员列表
        StudentList({
          page: this.currentPage,
          limit: this.pageSize,
          class_id: this.class_id,
          search: this.inputVal,
        }).then((res) => {
          this.studentArr = res.data.list;
          this.total = res.data.total;
          this.studentArr.map((item) => {
            if (item.image == 0 || !item.image) {
              // 默认图
              item.image = this.defalutImg;
            }
          });
        });
      } else {
        // 小组列表
        GroupList({
          page: this.currentPage,
          limit: this.pageSize,
          class_id: this.class_id,
          user_id: this.userInfo.id,
          search: this.inputVal,
        }).then((res) => {
          this.studentArr = res.data.group_list.list;
          this.total = res.data.group_list.total;
          this.studentArr.map((item) => {
            if (item.image == 0 || !item.image) {
              // 默认图
              item.image = this.defalutImg;
            }
          });
        });
      }
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 搜索
    searchFn() {
      this.currentPage = 1;
      this.requestCommonFn();
    },

    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      this.requestCommonFn();
    },
  },

  created() {
    this.title = this.$route.query.title;
    this.path = this.$route.path;
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.belong_class {
  background-color: #fff;
  /deep/ .search {
    .el-input {
      width: 250px;
    }
    .el-input__inner {
      width: 250px;
      height: 40px;
      border-radius: 4px 0 0 4px;
    }
    .sousuo {
      width: 70px;
      height: 40px;
      line-height: 40px;
      background-color: #3489ff;
      text-align: center;
      color: #fff;
    }
  }
  .count {
    font-size: 12px;
    color: #666;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
  }
  .uu {
    display: flex;
    flex-wrap: wrap;
    li {
      padding: 20px 0px;
      width: 147px;
      margin: 10px 25px;
      box-shadow: 0 0 36px 9px rgba(51, 51, 51, 0.05);
      text-align: center;
      border-radius: 10px;
      transition: 1s;
      cursor: pointer;
      p {
        line-height: 40px;
      }
      &:hover {
        transform: translate(0, -5px);
      }
    }
  }
}
</style>